<template>
  <div class="userpage">
    <Form
      class="userpage-form"
      ref="form"
      :rules="ruleCustom"
      :model="form"
      :label-width="80"
    >
      <FormItem prop="phone" label="手机号" class="ivu-form-item-required">
        <!--  @on-blur="phoneBlur" -->
        <Input
          v-model.trim="form.phone"
          :disabled="type == 'edit'"
          placeholder="请输入手机号"
        >
        </Input>
      </FormItem>
      <!-- <FormItem label="姓名" class="ivu-form-item-required">
        <Input v-model.trim="form.name" disabled :placeholder="namePlaceholder">
        </Input>
      </FormItem> -->
      <FormItem label="角色" prop="role">
        <Select v-model="form.role" clearable placeholder="请选择角色">
          <Option v-for="item in roleList" :value="item.id" :key="item.id">{{
            item.name
          }}</Option>
        </Select>
      </FormItem>
      <FormItem label="">
        <Button
          type="primary"
          :loading="loading"
          class="btn104"
          shape="circle"
          @click="save"
          >{{ type == "add" ? "邀请" : "保存" }}</Button
        >
        <Button
          shape="circle"
          class="ml-24 btn104"
          @click="link('/setting/userindex/userlist')"
          >取消</Button
        >
      </FormItem>
    </Form>
    <InviteModal v-if="showUrl" @close="closeInvite" :url="inviteUrl" />
  </div>
</template>

<script>
import {
  getRoleList,
  editUserV1,
  addUserV1,
  getChildUserInfoV1,
  getUcName,
  getInviteUrl,
} from "@/api/system";
import { getUserInfo } from "@/api/user";
import InviteModal from "./components/invite-modal.vue";

export default {
  name: "",
  components: {
    InviteModal,
  },
  data() {
    return {
      inviteUrl: "",
      showUrl: false,
      ruleCustom: {
        name: [
          {
            required: true,
            validator: _FORM.validate_len1,
            max_len: 16,
            trigger: "blur",
            label: "姓名",
          },
        ],
        phone: [
          {
            required: true,
            validator: _FORM.phone_rul,
            trigger: "blur",
            label: "手机号",
          },
        ],
        role: [
          {
            required: true,
            message: "请选择角色",
            type: "number",
            trigger: "change",
          },
        ],
      },
      form: {},
      userName: "",
      loading: false,
      roleList: [],
      id: 0,
      type: "add",
      resetPwd: false,
      account: "",
      ResetFlag: false,
      canEditName: true, //是否能修改名称
      namePlaceholder: "根据手机号自动获取",
      nameRule: [
        {
          required: true,
          validator: _FORM.validate_len1,
          max_len: 16,
          trigger: "blur",
          label: "姓名",
        },
      ],
    };
  },
  created() {
    let route = this.$route;
    this.type = route.query.type;
    this.userName = this.$store.state.username;
    this.getRoleList();
    if (route.query.type == "edit") {
      this.id = route.query.id;
      delete this.ruleCustom["name"];
      delete this.ruleCustom["phone"];
      console.log("this.id", this.id);
      this.getInfo();
    }
  },
  methods: {
    closeInvite() {
      this.showUrl = false;
      this.$router.push({ path: "/setting/userindex/userlist" });
    },
    phoneBlur() {
      getUcName({ phone: this.form.phone }).then((res) => {
        console.log(res, "此手机号是否注册过");
        this.canEditName = res.data.data ? false : true;
        if (this.canEditName == false) {
          //用户中心注册过，不可修改,且不能校验
          this.$set(this.form, "name", res.data.data);
          console.log(this.form, "form--");
          delete this.ruleCustom["name"];
        } else {
          this.form.name = "";
          this.$refs.form.validateField("phone", (valid) => {
            if (valid) {
              this.namePlaceholder = "根据手机号自动获取";
            } else {
              this.namePlaceholder = "该手机号未注册";
            }
          });
        }
      });
    },
    resetPwdFlag() {
      this.resetPwd = true;
      this.ResetFlag = true;
    },
    getInfo() {
      getChildUserInfoV1(this.id).then((res) => {
        console.log(res, "用户详情");
        let json = res.data.data;
        json.name = json.realname;
        json.phone = json.account;
        this.form = json;
        this.$set(this.form, "role", json.roleList[0].id);
        console.log("this.$store.state.username", this.$store.state.username);
      });
    },
    getRoleList() {
      getRoleList({ pageSize: 1000, isShowAdmin: 0 }).then((res) => {
        console.log(res, "角色列表");
        this.roleList = res.data.data;
      });
    },
    link(path) {
      this.$router.push({ path: path });
    },
    save() {
      this.form.roleIdList = [this.form.role];
      let data = this.form;
      if (this.type == "edit") this.form.id = this.id;
      console.log(data, "data--");
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          if (this.type == "add") {
            this.addSave(data);
          } else {
            this.editSave(data);
          }
        }
      });
    },
    addSave(data) {
      addUserV1(data)
        .then((res) => {
          console.log();
          this.loading = false;
          console.log(res, "添加修改用户");
          this.inviteUrl = res.data.data;
          this.showUrl = true;
          let tip = this.type == "add" ? "添加" : "修改";
          this.$Message.success(`${tip}成功`);
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    editSave(data) {
      editUserV1(data)
        .then((res) => {
          this.loading = false;
          console.log(res, "修改用户");
          this.$Message.success(`修改成功`);
          this.$router.push({ path: "/setting/userindex/userlist" });
        })
        .catch((err) => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss">
.userpage {
  width: 100%;
  height: 100%;
  background: #fff;
  padding: 24px 32px;
  &-form {
    width: 650px;
  }
}
</style>
